export type LogErrorFn = (
  error: Error | string,
  data?: Record<string, unknown>,
) => void;

const defaultLogError: LogErrorFn = (error, data) => {
  console.error(error, data);
};

let handler: LogErrorFn = defaultLogError;

/**
 * Allows the host application to route schema-engine errors to its own logger
 * (e.g. Sentry). Defaults to `console.error` so the engine stays self-contained.
 */
export const setLogErrorHandler = (fn: LogErrorFn): void => {
  handler = fn;
};

export const logError: LogErrorFn = (error, data) => handler(error, data);
